import { render } from "./RandomDrawer.vue?vue&type=template&id=2dede2cc&scoped=true"
import script from "./RandomDrawer.vue?vue&type=script&lang=js"
export * from "./RandomDrawer.vue?vue&type=script&lang=js"

import "./RandomDrawer.vue?vue&type=style&index=0&id=2dede2cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dede2cc"]])

export default __exports__